import { Modality } from '@uplift/types';
import { restClient } from '../../client';

export type TherapyTypesResponse = {
  therapyTypes: Modality[];
};

export const getTherapyTypes = async (): Promise<TherapyTypesResponse> => {
  try {
    return restClient.request<TherapyTypesResponse>('/api/v1/matching/therapy_types');
  } catch {
    return {
      therapyTypes: [],
    };
  }
};
